import React from 'react'

import './qrPage.scss'

import Menu from '../../../components/InternalMenu/Menu'

import foodIcon from '../../../assets/svg/qrIcon.svg'
import qrCodeSite from '../../../assets/svg/qrCodeSite.svg'

export default function index() {
  document.title = 'کیوآرکد'

  return (
    <main id='panel'>
      <Menu page={'qr'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='icon'>
                <img src={foodIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                کد QR
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <div className='form'>
            <div className="row">
              <div className='column'>
                <label htmlFor='foodPrice' className='qrPart'>
                  <span>
                    <img src={qrCodeSite} alt="" />
                  </span>
                </label>
              </div>
              <div className='column' style={{ width: 'auto' }}>
                <button>چاپ</button>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              تولید کیوآرکد‌
              <hr />
            </div>
            <div className="row" style={{ justifyContent: 'flex-start' }}>
              <div className='column'>
                <label htmlFor='foodPrice' className='settinInput'>
                  <span>
                    انتخاب آیتم * :
                  </span>
                </label>
                <select id='categoryName'>
                  <option value='0'>انتخاب کنید</option>
                </select>
                <small id='foodPriceAlert'>باید یک مورد انتخاب شود</small>
              </div>
              <div className='column' style={{ justifyContent: 'end', width: 'auto' }}>
                <button>تولید QR</button>
              </div>
            </div>
          </div>
          <button className='createButton'>ثبت تغییرات</button>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
